import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { ListCasesContainer } from './listcasescontainer';
import {
  addAirhepCompensationFinalRequest,
  dismissErrorCaseList,
  initCaseList,
  retrieveCaseListRequest,
  selectAllElemInList,
  selectElementInList,
  updateStatusSelectedCaseRequest,
} from '../../../usescases/caseList/caselist.action';
import {
  selectCaseErrors,
  selectCaseList,
  selectCaseListLoading,
  selectCaseListSize,
} from '../../../usescases/caseList/caselist.selector';
import { createSaisine, dismissSaisineFlag } from '../../../../saisinecontext/usecases/saisine.actions';
import { selectSaisineErrors } from '../../../../saisinecontext/usecases/saisine.selector';

const mapStateToProps = (state) => ({
  pathname: state.router.location.pathname,
  search: state.router.location.search,
  hash: state.router.location.hash,
  loading: selectCaseListLoading(state),
  list: selectCaseList(state),
  errors: selectCaseErrors(state),
  listSize: selectCaseListSize(state),
  saisineErrors: selectSaisineErrors(state),
});

const mapDispatchToProps = (dispatch) => ({
  push: (value) => dispatch(push(value)),
  retrieveCaseList: (search) => dispatch(retrieveCaseListRequest(search)),
  selectElemInList: (list, elem) => dispatch(selectElementInList(list, elem)),
  checkAllCase: (isChecked) => dispatch(selectAllElemInList(isChecked)),
  updateStatusList: (status, list) => dispatch(updateStatusSelectedCaseRequest(status, list)),
  dismissError: () => dispatch(dismissErrorCaseList()),
  initList: () => dispatch(initCaseList()),
  addAirhelpCompensationFinal: (list) => dispatch(addAirhepCompensationFinalRequest(list)),
  createSaisine: (claimIds) => dispatch(createSaisine(claimIds)),
  dismissSaisineFlag: () => dispatch(dismissSaisineFlag())
});

const ListCases = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ListCasesContainer);

export default ListCases;
